/**
 * getAdsConfigByAdProvider - Returns the proper adsConfig object from the external `app-configurations`
 * JSON containing Ad Provider specific properties; defaults to an empty object for easier destructuring.
 *
 * @param {string} provider - Video Ads Provider either `freewheel` or `google`
 * @param {object} adsConfig - External adsConfig object supporting multiple editions
 *
 * @return {object} - Config object containing client specific properties for `freewheel` or `google`
 */
export default function getAdsConfigByAdProvider(provider, adsConfig) {
    const activeAdProvider = provider || (adsConfig && adsConfig.activeAdProvider);
    const config = adsConfig || {};
    const defaultProvider = 'google';

    if (activeAdProvider && config[activeAdProvider]) {
        return {
            activeAdProvider,
            ...config,
            ...config[activeAdProvider]
        };
    }

    // Safety to ensure we return `freewheel` as the default
    if (config[defaultProvider]) {
        return {
            activeAdProvider: defaultProvider,
            ...config,
            ...config[defaultProvider]
        };
    }

    return {};
}



// WEBPACK FOOTER //
// ./app/lib/util/getAdsConfigByAdProvider.js